import serviceReducer from "./serviceCategory/serviceReducer";
import categoryReducer from "./serviceCategory/categoryReducer";

export default function (serviceCategory, action) {
    serviceCategory = serviceCategory.update('service', s => serviceReducer(s, action));
    serviceCategory = serviceCategory.update('category', c => categoryReducer(c, action));
    return serviceCategory;
}


// WEBPACK FOOTER //
// ./src/reducers/serviceCategoryReducer.js